import { useMemo } from 'react';

import { DateTime } from 'luxon';
import { SectionedInfo, useMantineTheme } from 'ui';
import { useMediaQuery } from 'ui/Hooks';

const EventDateTimeCard = ({
  startingAt,
  endingAt,
}: {
  startingAt?: string;
  endingAt?: string;
}) => {
  const { breakpoints } = useMantineTheme();
  const isLargerThanMedium = useMediaQuery(`(min-width: ${breakpoints.md})`);

  const dateSections = useMemo(() => {
    if (!startingAt || !endingAt) return null;

    const isOneDayEvent = DateTime.fromISO(startingAt).hasSame(
      DateTime.fromISO(endingAt ?? ''),
      'day'
    );

    if (isOneDayEvent) {
      const startTime = DateTime.fromISO(startingAt)
        .toLocaleString(DateTime.TIME_SIMPLE)
        .replace(' AM', 'am')
        .replace(' PM', 'pm');
      const endTime = DateTime.fromISO(endingAt)
        .toLocaleString(DateTime.TIME_SIMPLE)
        .replace(' AM', 'am')
        .replace(' PM', 'pm');
      const timezone = DateTime.fromISO(startingAt).toFormat('ZZZZ');

      return (
        <>
          <SectionedInfo.Item label="Date">
            {DateTime.fromISO(startingAt).toFormat('ccc, LLL d')}
          </SectionedInfo.Item>
          <SectionedInfo.Item label="Time">
            {`${startTime} - ${endTime} ${timezone}`}
          </SectionedInfo.Item>
        </>
      );
    }
    return (
      <SectionedInfo.Item label="Date">
        {DateTime.fromISO(startingAt).toFormat('ccc, LLL d')} -{' '}
        {DateTime.fromISO(endingAt).toFormat('ccc, LLL d')}
      </SectionedInfo.Item>
    );
  }, [startingAt, endingAt]);

  return dateSections ? (
    <SectionedInfo withCard size={isLargerThanMedium ? 'md' : 'sm'}>
      {dateSections}
    </SectionedInfo>
  ) : null;
};

export { EventDateTimeCard };
